import HighlightedLinkForm from './highlighted-link-form';

export default HighlightedLinkForm;
